import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import $ from 'jquery'

const Dropzone = Backbone.View.extend({

	className: 'porter-destination dropzone drop',

	events: {
		'dropShadow': 'onDropShadow'
	},

	initialize: function(options={}) {
		this.options = options

		this.$el.attr('data-id', this.cid)
		this.el.parentFeatureModel = options.parent
		this.el.featureModel = options.model
		this.el.axis = options.axis
	},

	render: function() {
		this.$el.text(i18n.get('admin.import.mapResults.drop'))
		this.showInactiveText()
		return this
	},

	onDropShadow: function(e, arg) {
		if (!arg.show) {
			this.showInactiveText()
			this.toggleVisibility(false)
			this.options.panel && this.options.panel.toggleDropHint(true)
			this.$el.removeClass('drop')
		} else {
			if (!_.isNil(this.options.panel)) {
				let dropzones = _.filter(this.options.panel.getAllDropzones(),
					dz => dz != this)
				_.invokeMap(dropzones, 'showInactiveText')
			}
			this.toggleVisibility(true)
			this.$el.text(i18n.get('admin.import.mapResults.drop'))
				.addClass('drop')
		}
	},

	showInactiveText: function(messageCode) {
		if (!_.isNil(messageCode)) {
			this.$el.text(i18n.get(messageCode))
			return
		}

		const hasEmptyParent = this.hasEmptyParent()
		if (this.$el.hasClass('temporarily-active') || hasEmptyParent) {
			this.$el
				.text(i18n.get('charts.feature.stack.dragHint'))
				.removeClass('drop')
		}
		hasEmptyParent && this.$el.addClass('initial')
	},

	toggleVisibility: function(show) {
		if (show) {
			$(this.options.panel.$el)
				.find('.dropzone')
				.removeClass('is-selected')
		}
		this.$el.toggleClass('is-selected', show)
	},

	isShowing: function() {
		return this.$el.hasClass('is-selected')
	},

	hasEmptyParent: function() {
		// if the dropzone is inside of a feature (i.e. stack) with no features
		let features = _.get(this.options, 'parent.children')
		if (_.isNil(features)) {
			return false
		}
		return features.length == 0
	}
})

export default Dropzone
Dropzone.__filename__ = 'charts/edit/dropzone.js'
